import { __assign } from "tslib";
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { N40A, N30A, N900 } from '@atlaskit/theme/colors';
import { HORIZONTAL_GLOBAL_NAV_HEIGHT } from '../../common/constants';
import { hexToRGBA } from '../../theme';
var gridSize = gridSizeFn();
export var containerCSS = function (_a) {
    var navigation = _a.mode.navigation;
    return (__assign(__assign({ alignItems: 'center', boxSizing: 'border-box', display: 'flex', flexShrink: 0, justifyContent: 'space-between', paddingLeft: gridSize * 1.5, paddingRight: gridSize * 1.5, height: HORIZONTAL_GLOBAL_NAV_HEIGHT, position: 'relative' }, bottomShadow), navigation));
};
export var leftCSS = {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    minWidth: 0,
    height: 'inherit',
    '& > *': {
        flexShrink: 0,
    },
};
export var rightCSS = {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    '& > *': {
        flexShrink: 0,
        marginRight: gridSize / 2,
    },
};
export var bottomShadow = {
    '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        top: '100%',
        height: gridSize / 2,
        background: "linear-gradient(180deg, " + N40A + " 0, " + N40A + " 1px, " + N30A + " 1px, " + hexToRGBA(N900, 0) + " 4px)",
    },
};
//# sourceMappingURL=styles.js.map